import React, { useState, useEffect } from "react";
// import { format } from "date-fns";
import axios from 'axios';

const Profile = () => {
  const [activeTab, setActiveTab] = useState("personal");
  const [isEditing, setIsEditing] = useState(false);
  const [userData, setUserData] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchUser = async () => {
      try {

        const token = localStorage.getItem("authToken");
        if (!token) return;
        const response = await axios.get(`${API_BASE_URL}/api/v1/auth/profile`, {
          headers: {
            Authorization: `Bearer ${token}`, // Send token for authentication
          },
        });

        setUserData(response.data); // Assuming response contains user data
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUser();
  }, [ API_BASE_URL]);

  // const memberSince = userData?.createdAt 
  // ? format(new Date(user.createdAt), "MMMM dd, yyyy") 
  // : "Unknown";

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsEditing(false);
    // Add your update logic here
  };

  return (
    <div className="max-w-4xl mx-auto">
      {/* Profile Header */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <div className="flex items-center gap-6">
          <div className="w-20 h-20 rounded-full bg-navy flex items-center justify-center">
            <span className="material-icons text-4xl text-white">person</span>
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-navy">{userData?.fullname}</h2>
            <p className="text-charcoal-gray"></p>
            <p className="text-sm text-light-gray">Member since </p>
          </div>
        </div>
      </div>

      {/* Profile Navigation */}
      <div className="bg-white rounded-lg shadow-md mb-6">
        <div className="flex border-b border-light-gray">
          <button
            onClick={() => setActiveTab("personal")}
            className={`flex-1 py-4 text-center font-medium transition-colors duration-200 ${
              activeTab === "personal"
                ? "text-emerald-green border-b-2 border-emerald-green"
                : "text-charcoal-gray hover:text-navy"
            }`}
          >
            Personal Information
          </button>
          <button
            onClick={() => setActiveTab("security")}
            className={`flex-1 py-4 text-center font-medium transition-colors duration-200 ${
              activeTab === "security"
                ? "text-emerald-green border-b-2 border-emerald-green"
                : "text-charcoal-gray hover:text-navy"
            }`}
          >
            Security
          </button>
          <button
            onClick={() => setActiveTab("bank")}
            className={`flex-1 py-4 text-center font-medium transition-colors duration-200 ${
              activeTab === "bank"
                ? "text-emerald-green border-b-2 border-emerald-green"
                : "text-charcoal-gray hover:text-navy"
            }`}
          >
            Bank Details
          </button>
        </div>
      </div>

      {/* Profile Content */}
      <div className="bg-white rounded-lg shadow-md p-6">
        {activeTab === "personal" && (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-lg font-semibold text-navy">Personal Information</h3>
              <button
                onClick={() => setIsEditing(!isEditing)}
                className="flex items-center gap-2 text-emerald-green hover:text-emerald-600"
              >
                <span className="material-icons">
                  {isEditing ? "close" : "edit"}
                </span>
                {isEditing ? "Cancel" : "Edit"}
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-charcoal-gray mb-2">Full Name</label>
                  <input
                    type="text"
                    value={userData?.fullname}
                    disabled={!isEditing}
                    className="w-full px-4 py-2 rounded-lg border border-light-gray focus:border-emerald-green focus:ring-1 focus:ring-emerald-green disabled:bg-soft-white"
                  />
                </div>
                {/* <div>
                  <label className="block text-charcoal-gray mb-2">Last Name</label>
                  <input
                    type="text"
                    value={userData.lastName}
                    disabled={!isEditing}
                    className="w-full px-4 py-2 rounded-lg border border-light-gray focus:border-emerald-green focus:ring-1 focus:ring-emerald-green disabled:bg-soft-white"
                  />
                </div> */}
                <div>
                  <label className="block text-charcoal-gray mb-2">Email</label>
                  <input
                    type="email"
                    value={userData?.email}
                    disabled={!isEditing}
                    className="w-full px-4 py-2 rounded-lg border border-light-gray focus:border-emerald-green focus:ring-1 focus:ring-emerald-green disabled:bg-soft-white"
                  />
                </div>
                <div>
                  <label className="block text-charcoal-gray mb-2">Phone Number</label>
                  <input
                    type="tel"
                    value={userData?.phone}
                    disabled={!isEditing}
                    className="w-full px-4 py-2 rounded-lg border border-light-gray focus:border-emerald-green focus:ring-1 focus:ring-emerald-green disabled:bg-soft-white"
                  />
                </div>
                {/* <div className="md:col-span-2">
                  <label className="block text-charcoal-gray mb-2">Address</label>
                  <input
                    type="text"
                    value={userData.address}
                    disabled={!isEditing}
                    className="w-full px-4 py-2 rounded-lg border border-light-gray focus:border-emerald-green focus:ring-1 focus:ring-emerald-green disabled:bg-soft-white"
                  />
                </div> */}
                {/* <div>
                  <label className="block text-charcoal-gray mb-2">State</label>
                  <input
                    type="text"
                    value={userData.state}
                    disabled={!isEditing}
                    className="w-full px-4 py-2 rounded-lg border border-light-gray focus:border-emerald-green focus:ring-1 focus:ring-emerald-green disabled:bg-soft-white"
                  />
                </div>
                <div>
                  <label className="block text-charcoal-gray mb-2">Country</label>
                  <input
                    type="text"
                    value={userData.country}
                    disabled={!isEditing}
                    className="w-full px-4 py-2 rounded-lg border border-light-gray focus:border-emerald-green focus:ring-1 focus:ring-emerald-green disabled:bg-soft-white"
                  />
                </div> */}
              </div>

              {isEditing && (
                <div className="mt-6 flex justify-end">
                  <button
                    type="submit"
                    className="bg-emerald-green hover:bg-opacity-90 text-white px-6 py-2 rounded-lg transition-colors duration-200"
                  >
                    Save Changes
                  </button>
                </div>
              )}
            </form>
          </div>
        )}

        {activeTab === "security" && (
          <div>
            <h3 className="text-lg font-semibold text-navy mb-6">Security Settings</h3>
            
            {/* Change Password Section */}
            <div className="mb-8">
              <h4 className="text-navy font-medium mb-4">Change Password</h4>
              <form className="space-y-4">
                <div>
                  <label className="block text-charcoal-gray mb-2">Current Password</label>
                  <input
                    type="password"
                    className="w-full px-4 py-2 rounded-lg border border-light-gray focus:border-emerald-green focus:ring-1 focus:ring-emerald-green"
                  />
                </div>
                <div>
                  <label className="block text-charcoal-gray mb-2">New Password</label>
                  <input
                    type="password"
                    className="w-full px-4 py-2 rounded-lg border border-light-gray focus:border-emerald-green focus:ring-1 focus:ring-emerald-green"
                  />
                </div>
                <div>
                  <label className="block text-charcoal-gray mb-2">Confirm New Password</label>
                  <input
                    type="password"
                    className="w-full px-4 py-2 rounded-lg border border-light-gray focus:border-emerald-green focus:ring-1 focus:ring-emerald-green"
                  />
                </div>
                <div>
                  <button
                    type="submit"
                    className="bg-emerald-green hover:bg-opacity-90 text-white px-6 py-2 rounded-lg transition-colors duration-200"
                  >
                    Update Password
                  </button>
                </div>
              </form>
            </div>

            {/* Two-Factor Authentication */}
            {/* <div>
              <h4 className="text-navy font-medium mb-4">Two-Factor Authentication</h4>
              <div className="flex items-center justify-between p-4 bg-soft-white rounded-lg">
                <div>
                  <p className="text-charcoal-gray">Enhance your account security</p>
                  <p className="text-sm text-light-gray mt-1">
                    Add an extra layer of security to your account
                  </p>
                </div>
                <button className="bg-navy hover:bg-opacity-90 text-white px-4 py-2 rounded-lg transition-colors duration-200">
                  Enable 2FA
                </button>
              </div>
            </div> */}
          </div>
        )}

        {activeTab === "bank" && (
          <div>
            <h3 className="text-lg font-semibold text-navy mb-6">Bank Details</h3>
            
            {/* Virtual Account Details */}
            <div className="bg-soft-white rounded-lg p-6 mb-6">
              <h4 className="text-navy font-medium mb-4">Your Virtual Account</h4>
              <div className="space-y-4">
                <div>
                  <p className="text-charcoal-gray text-sm">Bank Name</p>
                  <p className="text-navy font-medium">{userData?.virtualAccount.bankName}</p>
                </div>
                <div>
                  <p className="text-charcoal-gray text-sm">Account Number</p>
                  <p className="text-navy font-medium">{userData?.virtualAccount.accountNumber}</p>
                </div>
                <div>
                  <p className="text-charcoal-gray text-sm">Account Name</p>
                  <p className="text-navy font-medium">{userData?.virtualAccount.accountName} flw</p>
                </div>
              </div>
            </div>


{/* {hasAccount ? (
        <div>
          <h2>Your Virtual Account</h2>
          <p><strong>Bank Name:</strong> {virtualAccount.bankName}</p>
          <p><strong>Account Number:</strong> {virtualAccount.accountNumber}</p>
          <p><strong>Account Name:</strong> {virtualAccount.accountName}</p>
        </div>
      ) : (
        <form onSubmit={bvnHandleSubmit}>
          <label>Enter your BVN:</label>
          <input
            type="text"
            value={bvn}
            onChange={(e) => setBvn(e.target.value)}
            placeholder="Enter BVN"
            required
          />
          <button type="submit">Generate Virtual Account</button>
        </form>
      )} */}


            {/* Important Notice */}
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
              <div className="flex">
                <div className="flex-shrink-0">
                  <span className="material-icons text-blue-500">info</span>
                </div>
                <div className="ml-3">
                  <p className="text-sm text-blue-700">
                    This is your dedicated virtual account for funding your wallet. All transfers to this account will be automatically credited to your wallet.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;